import styled from 'styled-components';

export const FloydWrapper = styled.div`
  margin-top: -59px;
  img {
    max-width: 75px;
  }
`;
